module.exports = __webpack_public_path__ + "static/kairos-sans-4cc7b9e3b3708b1fff8e4095b8422b9a.woff2";